import { Component, ElementRef, EventEmitter, OnInit, Input, Output, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DataService } from '../../../core/data/data-service';
import { PromoContentService } from '../../../core/routing/services/asset-library/promo-content.service';
import { GlobalConstants } from './../../../common/constants/global.constant';
import { CreatePromoContentResponse, PromoContent, PromoContentConfiguration, PromoContentViewModel } from '../promo-content/interfaces/promo-content.i';
import moment from 'moment';
import { Utils } from '../../../common/utils/utils';
import { FormFactor } from '../form-factors/interfaces/form-factors.i';
import { utils } from 'protractor';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { CommonService } from '../../../common/services/common.service';

@Component({
  selector: 'iposcen-create-promo-content',
  templateUrl: './create-promo-content.component.html',
  styleUrls: ['./create-promo-content.component.scss']
})
export class CreatePromoContentComponent implements OnInit, OnDestroy {
  @Input() isNavigated: boolean;
  @Output() readonly goBacktoPromoContent = new EventEmitter<object>();
  @ViewChild('formFactorsModal') formFactorsModal: ElementRef;
  promoContentgrpForm: FormGroup;
  isPublishedDateInCorrect: boolean;
  isExpiredDateIncorrect: boolean;
  isSubmitted: boolean;
  isFormValid: boolean;
  isPublishDateCustomDatepicker: boolean;
  editPublishDateInfo: string;
  editexpiryDateInfo: string;
  isPublishExpiryNever: boolean;
  isExpiryDatePicker: boolean;
  promoCGToDeleteName: string;
  customPublishDateResult: string;
  customExpiryDateResult: string;
  dateTimeValue: string;
  expiryDateTime: string;
  selectedFormFactors: FormFactor;
  selectedPromoContentId: string;
  isCustomPublishDateCorrect: boolean;
  isCustomExpiryDateCorrect: boolean;
  selectedPromoContent: PromoContentViewModel;
  updatedSelectedPromoContent: PromoContentViewModel;
  promoContentGroupData: PromoContentConfiguration;
  deviceTypes = GlobalConstants.DEVICE_TYPES;
  manufacturers = GlobalConstants.MANUFACTURERS;
  processors = GlobalConstants.PROCESSORS;
  generation = GlobalConstants.GENERATION;
  publishNamePlaceholder = AssetLibraryConstants.PUBLISHED_NAME_PLACEHOLDER;
  internalNamePlaceholder = AssetLibraryConstants.INTERNAL_NAME_PLACEHOLDER;
  private ngUnsubscribe = new Subject<boolean>();
  isCustomPublishTimeZoneSelected = false;
  isCustomExpiryTimeZoneSelected = false;
  retailerUserId = sessionStorage.getItem('retailerId');
  constructor(
    private formBuilder: FormBuilder,
    private logoContentService: PromoContentService,
    private dataService: DataService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.dateTimeValue = '';
    this.expiryDateTime = '';
    this.isExpiredDateIncorrect = false;
    this.isCustomPublishDateCorrect = false;
    this.isCustomExpiryDateCorrect = false;
    this.customPublishDateResult = GlobalConstants.NOW;
    this.customExpiryDateResult = GlobalConstants.NEVER;
    this.dataService.getPromoContent()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((promoContentToEdit: any) => {
        if (promoContentToEdit) {
          this.updatedSelectedPromoContent = promoContentToEdit as unknown as PromoContentViewModel;
          this.logoContentService.buttonName = GlobalConstants.SAVE_CHANGES;
          this.selectedPromoContent = promoContentToEdit;
          this.selectedPromoContentId = promoContentToEdit.id;
          this.selectedFormFactors = this.selectedPromoContent.configurations.formFactor;
          if (promoContentToEdit.configurations.isPublishDateNow) {
            this.isPublishDateCustomDatepicker = false;
            this.editPublishDateInfo = GlobalConstants.NOW;
          } else {
            this.isPublishDateCustomDatepicker = true;
            this.customPublishDateResult = promoContentToEdit.configurations.publishTime;
            this.editPublishDateInfo = promoContentToEdit.configurations.publishTime;
          }
          if (promoContentToEdit.configurations.isPublishExpiryNever) {
            this.isExpiryDatePicker = false;
            this.editexpiryDateInfo = GlobalConstants.NEVER;
          } else {
            this.isExpiryDatePicker = true;
            this.customExpiryDateResult = promoContentToEdit.configurations.expireTime;
            this.editexpiryDateInfo = promoContentToEdit.configurations.expireTime;
          }
        } else {
          this.logoContentService.buttonName = GlobalConstants.SAVE_AND_PROCEED;
          this.selectedFormFactors = {
            allDevices: true,
            devices: GlobalConstants.ALL,
            manufacturer: GlobalConstants.ALL,
            processors: GlobalConstants.ALL,
            generations: GlobalConstants.ALL
          };
        }
      });

    this.isSubmitted = false;
    this.createLogoContentGroupForm();
    //To get original contengrouppages for normal edit flow
    if (this.selectedPromoContentId) {
      this.logoContentService.getPromoContentById(this.selectedPromoContentId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(getPromoContentById => {
          this.promoContentGroupData = JSON.parse(getPromoContentById.promotionalContent.configurations) as PromoContentConfiguration;
        },
          error => {
            // do something
          });
    }
    this.commonService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data === true) {
          this.commonService.setSwitchstatus(true);
        }
      });
  }

  getExpiryNever(time) {
    this.expiryDateTime = GlobalConstants.NEVER;
  }

  getSelectedTime(time) {
    this.dateTimeValue = time;
  }

  getExpirySelectedTime(time) {
    this.expiryDateTime = time;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openFormFactorsModal() {
    this.openModal(this.formFactorsModal);
  }

  applyFormFactor(updatedFormFactors) {
    // console.log('received value:: ' + JSON.stringify(updatedFormFactors));
    this.selectedFormFactors = updatedFormFactors;
    this.closeModal(this.formFactorsModal);
  }

  createLogoContentGroupForm() {
    // TODO -- need to add validations for form fields
    this.promoContentgrpForm = this.formBuilder.group({
      publishedName: new FormControl((this.selectedPromoContent) ? this.selectedPromoContent.configurations.publishedName : '',
        [Validators.required, Validators.maxLength(50)]),
      publishedTimeStamp: new FormControl((this.selectedPromoContent) ?
        this.selectedPromoContent.configurations.publishTime : GlobalConstants.NOW),
      internalName: new FormControl((this.selectedPromoContent) ?
        this.selectedPromoContent.configurations.internalName : ''),
      expiryTimeStamp: new FormControl((this.selectedPromoContent) ?
        this.selectedPromoContent.configurations.expireTime : GlobalConstants.NEVER)
    });
  }

  checkCurrentDate() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    var hour = today.getHours();
    var minute = today.getMinutes();
    var dateInfo = `${mm}/${dd}/${yyyy}`;
    var time = `${hour}:${minute}`;
    var timeZone = today.toTimeString().slice(9);
    if (timeZone.length > 30) {
      timeZone = timeZone.substring(0, 30);
      timeZone = `${timeZone}...`;
    };
    var currentDateResult = `${dateInfo} ${time} ${timeZone}`;
    currentDateResult = currentDateResult.toString();
    return currentDateResult;
  }

  createNewPromoContent() {
    if (this.dateTimeValue.toString() === '') {
      this.dateTimeValue = this.checkCurrentDate();
    }
    const promoFactor: FormFactor = Utils.getFormFactorValues(this.selectedFormFactors);
    const promoContent: PromoContentConfiguration = {
      publishedName: this.promoContentgrpForm.controls.publishedName.value.trim(),
      internalName: this.promoContentgrpForm.controls.internalName.value,
      publishTime: (this.customPublishDateResult.toString() !== GlobalConstants.NOW) ?
        this.customPublishDateResult.toString() : Utils.getCurrentDate(),
      expireTime: (this.customExpiryDateResult.toString() !== GlobalConstants.NEVER) ?
        this.customExpiryDateResult.toString() : GlobalConstants.NEVER,
      contentScheduleTimezoneCode: 'CST',
      formFactor: promoFactor,
      type: GlobalConstants.PROMO_CONTENT_GROUP,
      contentGroupPages: [],
      isPublishDateNow: !this.isPublishDateCustomDatepicker,
      isPublishExpiryNever: !this.isExpiryDatePicker
    };
    if (promoContent.expireTime !== GlobalConstants.NEVER) {
      promoContent.expireTime = Utils.changeSaveDateFormat(promoContent.expireTime);
    }
    if (!promoContent.isPublishDateNow) {
      promoContent.publishTime = Utils.changeSaveDateFormat(promoContent.publishTime);
    }
    this.logoContentService.createPromoContent(JSON.stringify(promoContent))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(createPromoContentResponse => {
        const createPromoContentResponseObj: CreatePromoContentResponse = createPromoContentResponse as CreatePromoContentResponse;
        this.goBacktoPromoContent.emit(createPromoContentResponseObj);
      },
        error => {
        });
  }

  updatePromoContent() {
    if (this.dateTimeValue.toString() === '') {
      this.dateTimeValue = this.checkCurrentDate();
    }
    const promoContent = this.selectedPromoContent as unknown as PromoContent;
    if(promoContent.configurations['previewType'] == undefined || promoContent.configurations['idleExpFullscreenEnabled'] == undefined) {
      promoContent.configurations['previewType'] = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
      promoContent.configurations['idleExpFullscreenEnabled'] = false;
    }
    const promoFactor: FormFactor = Utils.getFormFactorValues(this.selectedFormFactors);
    if (this.dateTimeValue.toString() === '') {
      this.dateTimeValue = this.checkCurrentDate();
    }
    const promoContentConfig: PromoContentConfiguration = {
      publishedName: this.promoContentgrpForm.controls.publishedName.value.trim(),
      internalName: this.promoContentgrpForm.controls.internalName.value,
      publishTime: (this.customPublishDateResult.toString() !== GlobalConstants.NOW) ?
        this.customPublishDateResult.toString() : Utils.getCurrentDate(),
      expireTime: (this.customExpiryDateResult.toString() !== GlobalConstants.NEVER) ?
        this.customExpiryDateResult.toString() : GlobalConstants.NEVER,
      contentScheduleTimezoneCode: 'CST',
      formFactor: promoFactor,
      type: GlobalConstants.PROMO_CONTENT_GROUP,
      contentGroupPages: this.promoContentGroupData.contentGroupPages,
      isPublishDateNow: !this.isPublishDateCustomDatepicker,
      isPublishExpiryNever: !this.isExpiryDatePicker
    };
    if (promoContentConfig.expireTime !== GlobalConstants.NEVER) {
      promoContentConfig.expireTime = Utils.changeSaveDateFormat(promoContentConfig.expireTime);
    }
    if (!promoContentConfig.isPublishDateNow) {
      promoContentConfig.publishTime = Utils.changeSaveDateFormat(promoContentConfig.publishTime);
    }
    const promoContentConfigObj: PromoContentConfiguration = this.updatedSelectedPromoContent.configurations as PromoContentConfiguration;
    promoContent.configurations = JSON.stringify(promoContentConfig);
    this.logoContentService.putPromoContentById(JSON.stringify(promoContent), this.selectedPromoContentId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(putPromoContentResponse => {
        if (this.isNavigated) {
          const promoContentResponseObj = { promotionalContent: putPromoContentResponse.promotionalContent };
          promoContentResponseObj.promotionalContent.configurations =
            JSON.parse(promoContentResponseObj.promotionalContent.configurations) as PromoContentConfiguration;
          promoContentResponseObj.promotionalContent.configurations.contentGroupPages = promoContentConfigObj.contentGroupPages;
          this.goBacktoPromoContent.emit(promoContentResponseObj);
        } else {
          const createPromoContentResponseObj: CreatePromoContentResponse = putPromoContentResponse as CreatePromoContentResponse;
          this.goBacktoPromoContent.emit(createPromoContentResponseObj);
        }
        const createPromoContentResponseObj: CreatePromoContentResponse = putPromoContentResponse as CreatePromoContentResponse;
        this.goBacktoPromoContent.emit(createPromoContentResponseObj);
      },
        error => {
        });
  }

  cancel() {
    this.isSubmitted = false;
    this.goBacktoPromoContent.emit({ cancel: true });
    this.dataService.setPromoContent(undefined);
  }

  // check if published date is smaller than today's date
  checkPublishedDateTime() {
    const today = new Date();
    let isPublishedDateSmaller;
    if (this.promoContentgrpForm.controls.publishedTimeStamp.toString() !== '') {
      isPublishedDateSmaller = new Date(this.promoContentgrpForm.controls.publishedTimeStamp.value).getTime() < new Date().getTime();
    }

    this.isPublishedDateInCorrect = isPublishedDateSmaller;
  }

  // check if expiry date is smaller than published date
  checkExpiryDateTime() {
    if (this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = Utils.customDateCheck(this.customPublishDateResult, this.customExpiryDateResult);
    }
  }
  customValidation() {
    if (this.isPublishDateCustomDatepicker) {
      this.isCustomPublishDateCorrect = (this.customPublishDateResult === GlobalConstants.NOW);
    }
    if (this.isExpiryDatePicker) {
      this.isCustomExpiryDateCorrect = (this.customExpiryDateResult === GlobalConstants.NEVER);
    }
  }

  onAdd() {
    this.isSubmitted = true;
    this.checkExpiryDateTime();
    this.customValidation();
    this.isFormValid = !this.isPublishedDateInCorrect && !this.isExpiredDateIncorrect &&
      !this.isCustomExpiryDateCorrect &&
      !this.isCustomPublishDateCorrect &&
      this.promoContentgrpForm?.controls?.publishedName?.value.trim() !== ''
      && !this.promoContentgrpForm?.controls?.publishedName?.errors?.maxlength &&
      !this.isCustomPublishTimeZoneSelected && !this.isCustomExpiryTimeZoneSelected;
    if (this.isFormValid) {
      if (this.selectedPromoContentId) { // Since promo content id exists, it is an update process
        this.updatePromoContent();
      } else {
        this.createNewPromoContent();
      }
    }
  }

  selectCustomPublishDate(datetimeOption) {
    this.isPublishDateCustomDatepicker = this.checkStatus(datetimeOption);
    if (!this.isPublishDateCustomDatepicker && this.customPublishDateResult !== GlobalConstants.NOW) {
      this.customPublishDateResult = Utils.getCurrentDate();
    }
    if (datetimeOption === GlobalConstants.NOW) {
      this.isCustomPublishDateCorrect = false;
      this.isCustomPublishTimeZoneSelected = false;
    }
  }

  selectExpiryDateTimeZone(datetimeOption) {
    this.isExpiryDatePicker = this.checkStatus(datetimeOption);
    if(this.isExpiryDatePicker && this.editexpiryDateInfo) {
      this.customExpiryDateResult = this.editexpiryDateInfo;
    }
    if (!this.isExpiryDatePicker && this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.customExpiryDateResult = GlobalConstants.NEVER;
    }
    if (datetimeOption === GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = false;
      this.isCustomExpiryDateCorrect = false;
      this.isCustomExpiryTimeZoneSelected = false;
    }
  }

  checkStatus(status) {
    return (status === GlobalConstants.CUSTOM);
  }

  getLogoContentPublishDate(data) {
    this.customPublishDateResult = this.generateDateTimeZone(data);
  }

  getLogoContentExpiryDate(data) {
    this.customExpiryDateResult = this.generateDateTimeZone(data);
  }

  generateDateTimeZone(data) {
    return `${moment(data.dateVal).format(GlobalConstants.DATE_FORMAT)} ${data.hour}:${data.min} ${data.timeZone}`;
  }
  checkIfTimeset(data, check) {
    if (check === 'publish') {
      if (data[0] && data[1]) {
        this.isCustomPublishDateCorrect = false;
      }
    } else {
      if (data[0] && data[1]) {
        this.isCustomExpiryDateCorrect = false;
      }
    }
  }

  checkTimeZone(data, check) {
    (check === GlobalConstants.PUBLISH) ? (this.isCustomPublishTimeZoneSelected = !data) : (this.isCustomExpiryTimeZoneSelected = !data);
  }
}
